import { render, staticRenderFns } from "./ItemListOpenMyLayout.vue?vue&type=template&id=832bdf84&scoped=true"
import script from "./ItemListOpenMyLayout.vue?vue&type=script&lang=js"
export * from "./ItemListOpenMyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832bdf84",
  null
  
)

export default component.exports